<template>
  <div class="ticker">
    <p class="visually-hidden">Technologies we work with: {{ items.join(', ') }}</p>
    <div class="ticker__track" aria-hidden="true">
      <ul v-for="n in 2" :key="n" class="ticker__list">
        <li v-for="item in items" :key="item" class="ticker__item">{{ item }}</li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Ticker',
  data() {
    return {
      items: [
        'Solidity',
        'Ethereum',
        'BNB Smart Chain',
        'Polygon',
        'ERC-20',
        'ERC-721',
        'BEP-20',
        'DeFi',
        'Cross-chain bridges',
        'deBridge',
        'IPFS',
        'OpenSea',
        'Proxy upgrades',
        'Staking & vesting'
      ]
    }
  }
}
</script>
